// @flow
import React, {PureComponent} from 'react';
import {StyleSheet, View} from 'react-native';
import {Frame} from '../../common';
import UsageSwiper from '../UsageSwiper';
import I18n from '../../../lib/i18n';

class UsageFrame extends PureComponent<Props> {
  render() {
    const {usages, isFetching} = this.props;
    // Hide the frame only when the user cannot top-up AND there is no usage
    // data to display. If canBoostPlan is true, the frame header must remain
    // visible because it is the primary entry point to the top-up flow.
    if (!this.props.canBoostPlan && !usages.length && !isFetching) {
      return null;
    }
    const usagesArray = isFetching && !usages.length ? null : usages;

    return (
      <Frame
        title={I18n.t('Dashboard.Usage.title')}
        onToggleFolded={this.props.canBoostPlan && this.props.onTitlePress}
        toggleTitle={I18n.t('Dashboard.Usage.actionTitle')}
        folded
        headerTouchableOnly
        style={[styles.container, this.props.style]}
        titleContainerStyle={styles.frameTitleContainer}
        testID="usageFrame"
        headerTestID="dashboard-topup-button">
        <Frame.Content style={styles.content}>
          <View style={styles.contentFrame}>
            <UsageSwiper
              usages={usagesArray}
              activeUsage={null}
              onUsagePress={this.props.onUsagePress}
            />
          </View>
        </Frame.Content>
      </Frame>
    );
  }
}

type Props = {
  isFetching: boolean,
  canBoostPlan: boolean,
  onUsagePress: Function,
  onTitlePress: Function,
  usages: Object[],
  style?: any,
};

const styles = StyleSheet.create({
  container: {
    paddingTop: 8,
  },
  frameTitleContainer: {
    marginHorizontal: 16,
  },
  contentFrame: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  content: {
    paddingTop: 15,
  },
});

export default UsageFrame;
